module.exports = __webpack_public_path__ + "img/svg/background-menu.2db6e167072fb675b2083b38b5fa578d.svg";